var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_Cashy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_Homepage",
    transform: "translate(-708.000000, -8177.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Locations_Section",
    transform: "translate(120.000000, 7463.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(568.000000, 694.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#F2F4F8",
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 260,
    height: 59,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.01,32.38 C35.78,32.38 34.59,32.18 33.48,31.82 C33.13,31.7 32.74,31.79 32.47,32.06 L30.9,34.03 C28.07,32.68 25.42,30.13 24.01,27.2 L25.96,25.54 C26.23,25.26 26.31,24.87 26.2,24.52 C25.83,23.41 25.64,22.22 25.64,20.99 C25.64,20.45 25.19,20 24.65,20 L21.19,20 C20.65,20 20,20.24 20,20.99 C20,30.28 27.73,38 37.01,38 C37.72,38 38,37.37 38,36.82 L38,33.37 C38,32.83 37.55,32.38 37.01,32.38 Z",
    id: "Path",
    fill: "#A0ADC8",
    fillRule: "nonzero"
  })))))));
};
export default SvgPhone;